import { format, parseISO } from 'date-fns';
const constants = require('./constants');

/**
 * Rebuilds a tree given a list with items that have fields id, parent_id
 * @param {*} list 
 */
function buildTree(list) {
    var map = {}, node, roots = [], i;
    
    for (i = 0; i < list.length; i += 1) {
      map[list[i].id] = i; // initialize the map
      list[i].children = []; // initialize the children
    }
    
    for (i = 0; i < list.length; i += 1) {
      node = list[i];
      if (node.parent_id !== null && node.parent_id !== constants.cmsConstants.parentSiteId) {
        // if you have dangling branches check that map[node.parent_id] exists
        list[map[node.parent_id]].children.push(node);
      } else {
        roots.push(node);
      }
    }
    return roots;
}
/**
 * Rebuilds a tree given a list with items that have fields id, parentId
 * @param {*} list 
 */
function buildSignageSitesTree(list) {
    var map = {}, node, roots = [], i;
    
    for (i = 0; i < list.length; i += 1) {
      map[list[i].id] = i; // initialize the map
      list[i].children = []; // initialize the children
    }
    
    for (i = 0; i < list.length; i += 1) {
      node = list[i];
      if (node.parentId !== null && node.parentId !== constants.cmsConstants.parentSiteId) {
        // if you have dangling branches check that map[node.parentId] exists
        if(map[node.parentId]){
          list[map[node.parentId]].children.push(node);
        }else{
          roots.push(node);
        }
      } else {
        roots.push(node);
      }
    }
    return roots;
}

function timeSince(date) {

  var seconds = Math.floor((new Date() - date) / 1000);

  var interval = seconds / 31536000;

  if (interval > 1) {
    return Math.floor(interval) + " years";
  }
  interval = seconds / 2592000;
  if (interval > 1) {
    return Math.floor(interval) + " months";
  }
  interval = seconds / 86400;
  if (interval > 1) {
    return Math.floor(interval) + " days";
  }
  interval = seconds / 3600;
  if (interval > 1) {
    return Math.floor(interval) + " hours";
  }
  interval = seconds / 60;
  if (interval > 1) {
    return Math.floor(interval) + " minutes";
  }
  return Math.floor(seconds) + " seconds";
}

function formatDate(dateString) {
  const date = new Date(dateString);
  const options = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  };
  return date.toLocaleString('en-US', options);
};

function formatScheduler(scheduler) {
  if (!scheduler) return '';
  
  const { timeStart, timeEnd, recurrenceDays, type } = scheduler;
  
  // Format dates (assuming they're in YYYY-MM-DD format)
  const startDate = new Date(timeStart).toLocaleDateString('en-US', { 
    year: 'numeric', 
    month: '2-digit', 
    day: '2-digit' 
  });
  const endDate = new Date(timeEnd).toLocaleDateString('en-US', { 
    year: 'numeric', 
    month: '2-digit', 
    day: '2-digit' 
  });
  
  // Format times (assuming they're in HH:MM:SS format)
const formatTime = (timeStr) => {
  const date = new Date(timeStr);
  const hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  const displayHour = hours % 12 || 12;
  return `${displayHour}:${minutes} ${ampm}`;
};

  const startTime = formatTime(timeStart);
  const endTime = formatTime(timeEnd);

  if (type === "daily") {
    return `${startDate} - ${endDate} ${startTime}-${endTime} Daily`;
  } else {
    // Format days of the week
    const dayNames = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'];
    const activeDays = recurrenceDays
      .map((isActive, index) => isActive ? dayNames[index] : null)
      .filter(Boolean)
      .join(' ');

    return `${startDate} - ${endDate} ${startTime}-${endTime} ${activeDays}`;
  }
}

function exportToCsv(options) {
  const {
    dataMap,
    selectedIds,
    columnMapping,
    filename = 'export.csv'
  } = options;

  // Get selected items from dataMap
  const selectedItems = Object.values(dataMap.data).filter(item => selectedIds[item.id]);
  
  if (selectedItems.length === 0) {
    console.warn('No items selected for export');
    return;
  }

  // Transform data using column mapping
  const csvData = selectedItems.map((item) => {
    const row = {};
    Object.entries(columnMapping).forEach(([csvHeader, itemKey]) => {
      row[csvHeader] = item[itemKey] || '';
    });
    return row;
  });

  // Escape CSV fields
  const escapeCsvField = (field) => {
    if (typeof field === 'string') {
      return `"${field.replace(/"/g, '""')}"`;
    }
    return field;
  };

  // Generate CSV content
  const csv = [
    Object.keys(csvData[0]).map(escapeCsvField).join(','), // Header row
    ...csvData.map((row) => Object.values(row).map(escapeCsvField).join(',')), // Data rows
  ].join('\n');

  // Create and download the file
  const blob = new Blob([csv], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}

function formatUtcDate(timeString) {
  const date = parseISO(timeString);
  const formattedDate = format(date, 'MMM d, yyyy');
  return formattedDate;
}

const methods = {
  buildTree,
  buildSignageSitesTree,
  timeSince,
  formatDate,
  formatUtcDate,
  formatScheduler,
  exportToCsv
}

export default methods;